import { routes } from '../RouterPath';
import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const editCollectionBreadcrumbs = (collectionName = '') : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Коллекции',
        url: routes.collections,
    },
    {
        key: '3',
        value: collectionName,
        url: '',
    },
]);
